// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"50":"datadogProfiler","133":"datadogRecorder"}[chunkId] || chunkId) + "." + {"50":"068d8a12","133":"aca88405","787":"e8d17bb7"}[chunkId] + ".chunk.js";
};